<template>
  <div>
    <table class="prop-table mb-2">
      <tr>
        <th>Participant amount</th>
        <td>{{calcContestParticipantAmount(stat.leagues) | getFormattedNumber}}</td>
      </tr>
    </table>

    <h4>Assemblies</h4>
    <league-stat
      v-for="league in stat.leagues"
      :key="league.id"
      :league="league"
      class="mb-3"
    />

  </div>
</template>

<script>
import LeagueStat from './contest/LeagueStat.vue';
import { calcContestParticipantAmount } from '../model/contest.js';

export default {
  name: 'TmntIndividualStat',

  components: {
    LeagueStat,
  },

  props: {
    stat: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.stat.leagues.sort((a, b) => b.id - a.id);
  },

  methods: {
    calcContestParticipantAmount,
  },
};
</script>
